<template>
  <div class="container">
    <img class="bg" prefetch src="https://oss.turingsenseai.com/1642581339246032822.png" alt="">

    <div v-if="query.category === '1'" class="cards">
      <div class="card" @click="select(1)">
        <div class="top">
          <img src="https://oss.turingsenseai.com/1643013864566983687.png">
        </div>
        <div class="bottom">
          <div class="b1">身份证</div>
          <div class="b2">ID card</div>
        </div>
      </div>
    </div>
    <div v-if="query.category === '2'" class="cards">
      <div class="card" @click="select(2)">
        <div class="top">
          <img src="https://oss.turingsenseai.com/1643013900880028439.png">
        </div>
        <div class="bottom">
          <div class="b1">营业执照</div>
          <div class="b2">Business License</div>
        </div>
      </div>
    </div>
    <!-- <div v-if="query.category === '3'" class="cards">
      <div class="card" @click="select(3)">
        <div class="top">
          <img src="https://oss.turingsenseai.com/1643013915134362258.png">
        </div>
        <div class="bottom">
          <div class="b1">风景照</div>
          <div class="b2">Scenery</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { Toast, ImagePreview } from 'vant';


Toast.setDefaultOptions({ duration: 2000 });
export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data(){
    return {
      takePhoto: false,
      success: false,
      loading: false,
      imgUrl: null,
      query: {}
    }
  },
  created(){
    this.query = this.$route.query;

    switch(this.query.category){
      case '1': 
        document.title='选择证件类型';
        break;
      case '2': 
        document.title='选择执照类型';
        break;
      // case '3': 
      //   document.title='选择自然图片类型';
        // break;
    }
  },
  methods: {
    select(p){
      this.$router.push(`stage?type=${p}&category=${this.query.category}`)
    },
    async afterRead(file){

    }
  }
}
</script>

<style lang="scss">
  .container{
    .bg{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
    }

    .cards{
      position: absolute;
      top: 0;
      left: 0;
      padding: 70px;
      .card{
        img{
          width: 244px;
          // box-shadow: -3.99899px 19.4338px 55.9859px rgba(58, 148, 255, 0.11);
        }

        .bottom{
          text-align: center;
          margin-top: 30px;
          .b1{
            color: #1E77E1;
            font-size: 32px;
            font-weight: 400;
          }
          .b2{
            color: #3A94FF;
            font-size: 24px;
            opacity: 0.5;
          }
        }

    }
    
    }
  }


</style>